import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, Modal, Space, Table, Tooltip, message } from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { setBreadcrumbItems } from "../../store/actions";

const Products = (props) => {
  const [product, setProduct] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const fetchProduct = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASEURL}/product`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProduct(response.data);
    } catch (err) {
      message.error("Failed to load products");
    }
  };

  useEffect(() => {
    const breadcrumbItems = [
      { title: "Products", link: "#" },
      { title: "Product Listing", link: "#" },
    ];
    props.setBreadcrumbItems("Product", breadcrumbItems);

    if (token) {
      fetchProduct();
    } else {
      message.error("Session expired, please login again");
    }
  }, [token]);

  const handleDelete = async (productId, productName) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASEURL}/product/${productId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      message.success(`Deleted product: ${productName}`);
      fetchProduct();
    } catch (err) {
      message.error("Failed to delete product");
    }
  };

  const filteredData = product.filter((p) => {
    const search = searchText.toLowerCase();
    return (
      p?.productName?.toLowerCase()?.includes(search) ||
      p?.productDescription?.toLowerCase()?.includes(search) ||
      p?.price?.toString().toLowerCase().includes(search) ||
      p?.quantity?.toString().toLowerCase().includes(search)
    );
  });

  const paginatedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const columns = [
    {
      title: "Image",
      dataIndex: "productImgUrl",
      key: "productImgUrl",
      render: (images) => (
        <Space>
          {images && images.length > 0 ? (
            <img
              src={`data:image/jpeg;base64,${images[0]}`}
              alt="Product"
              style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 4 }}
            />
          ) : (
            <span>No Image</span>
          )}
        </Space>
      ),
    },
    { title: "Product Name", dataIndex: "productName", key: "productName" },
    { title: "Description", dataIndex: "productDescription", key: "productDescription" },
    { title: "Price", dataIndex: "price", key: "price" },
    { title: "Quantity", dataIndex: "quantity", key: "quantity" },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => navigate(`/edit-products/${record._id}`)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="text"
              icon={<DeleteOutlined />}
              style={{ color: PRIMARY_RED }}
              onClick={() => {
                setSelectedProduct(record);
                setIsModalVisible(true);
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Row>
        <Col xs="12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <input
              type="text"
              placeholder="Search products..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250, padding: "6px 10px" }}
            />
            <Button
              type="primary"
              icon={<PlusOutlined />}
              style={{ backgroundColor: PRIMARY_RED }}
              onClick={() => navigate("/add-product")}
            >
              Add Product
            </Button>
          </div>

          <Card>
            <Modal
              title="Delete Product"
              visible={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
              footer={[
                <Button key="cancel" onClick={() => setIsModalVisible(false)} style={{ backgroundColor: "#6c757d", color: "white" }}>
                  Close
                </Button>,
                <Button
                  key="delete"
                  type="primary"
                  style={{ backgroundColor: PRIMARY_RED }}
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    handleDelete(selectedProduct._id, selectedProduct.productName);
                    setIsModalVisible(false);
                  }}
                >
                  Delete
                </Button>,
              ]}
            >
              <p>Are you sure you want to delete <strong>{selectedProduct?.productName}</strong> product?</p>
            </Modal>

            <CardBody>
              <Table
                columns={columns}
                dataSource={paginatedData}
                rowKey="_id"
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: filteredData.length,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "50"],
                }}
                onChange={handleTableChange}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(Products);
